
import { Component, Prop, Vue } from "vue-property-decorator";

const EMPLOYER_ROLE_TEMPLATE_ROUTE = "EmployerRoleTemplates";

const MESSAGES = {
  states: {
    create: {
      title: "Create or manage role templates",
      steps: [
        "Create a role template.",
        "Edit an existing one.",
        "Use the role templates for multiple services and candidates.",
      ],
    },
    choose: {
      title: "Choose the role template",
      steps: [
        "Select the role template.",
        "Or create a new one. Use the role templates for multiple services and candidates.",
        "Once it’s done, you’ll be able to start the service.",
      ],
    },
    empty: {
      title: "Start with creating a role template you are hiring for",
      steps: [
        "Create a role template.",
        "Use the role templates for multiple services and candidates.",
        "Once it’s done, you’ll be able to start the service.",
      ],
    },
  },
  buttons: {
    addNewTemplate: "Add new template",
  },
};

const CREATE_STATE = "create";
const CHOOSE_STATE = "choose";
const EMPTY_STATE = "empty";

const ICONS = {
  add: "add",
};

@Component
export default class WidgetCreateOrChooseRoles extends Vue {
  @Prop({ type: Boolean, default: false }) readonly empty?: boolean;
  @Prop({ type: Boolean, default: false }) readonly selecting?: boolean;

  get state() {
    if (this.empty) return EMPTY_STATE;

    return this.selecting ? CHOOSE_STATE : CREATE_STATE;
  }

  get showPortal() {
    return this.$route.name === EMPLOYER_ROLE_TEMPLATE_ROUTE;
  }

  messages = MESSAGES;
  icons = ICONS;

  addNewRole() {
    this.$emit("add-new-role-template");
  }
}
